// ESM-Huelle fuer lib/scripts/CLS_CEventDispatcher.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.


function CEventDispatcher() {
	this.locked = false;

	this.applyTS = true;
	this.updateTS(this);
	var me = this;
	this.BarcodeReader = new CBarcodeReader();

	$(document).scannerDetection({
		timeBeforeScanTest : 200, // wait for the next character for upto 200ms
		endChar : [13], // be sure the scan is complete if key 13 (enter) is detected
		avgTimeByChar : 40, // it's not a barcode if a character takes longer than 40ms
		//ignoreIfFocusOn : 'input', // turn off scanner detection if an input has focus
		onComplete : function (barcode, qty) {

			var l = barcode.length / qty;
			var charcode = 1;
			for (var x = 0; x < l; x++) {
				var c = barcode.charAt(x);
				var e = {
					'char' : c,
					'charCode' : charcode
				};
				me.keyupEvent(e);
			}
			charcode = 0;
			e = {
				'char' : '',
				"charCode" : charcode
			};
			me.keyupEvent(e);
			barcode = '';
			qty = 1;
		},
		minLength : 4, // Minimum length for a scanning
		//scanButtonKeyCode : 116, // the hardware scan button acts as key 116 (F5)
		scanButtonLongPressThreshold : 5, // assume a long press if 5 or more events come in sequence
		//onScanButtonLongPressed : showKeyPad, // callback for long pressing the scan button
		onError : function (string) {
//			alert('Error ' + string);
		}
	});

	//    window.captureEvents(Event.KEYUP);
	//    window.captureEvents(Event.MOUSEMOVE);
	//window.onkeypress = this.keyupEvent;
	window.onmousemove = this.mousemoveEvent;
	window.onmousedown = this.mousedownEvent;
	window.oncontextmenu = new Function("return false");

	/*$(document).keypress(function(e){
	var checkWebkitandIE=(e.which==26 ? 1 : 0);
	var checkMoz=(e.which==122 && e.ctrlKey ? 1 : 0);

	if (checkWebkitandIE || checkMoz) $("body").append("<p>ctrl+z detected!</p>");
	});*/

	this.callbacks = new Array();
	this.callback = function () {
		this.cls = null;
		this.fnc = null;
		this.onlyOnce = null;
	};

	this.lastFocusedComponent = null;
}

CEventDispatcher.prototype.updateTS = function (me) {
	var d = new Date();
	me.lastTS = (d / 1000).toFixed(0);
}

CEventDispatcher.prototype.eventTrigger = function (element, event, eventObj) {
	try {
		if (POS.events.locked == true) {
			log.add(4, "INFO", "Event was locked on " + id + "!", event);
			// Diagnose "Kasse haengt": steht die Sperre auffaellig lange, einmal
			// je Sperre protokollieren, welcher Handler sie haelt.
			var gesperrt = Date.now() - POS.events.lockedSince;
			if (gesperrt > 5000 && !POS.events.lockWarned) {
				POS.events.lockWarned = true;
				log.add(1, "Warning", "Eingabe gesperrt seit " + Math.round(gesperrt / 1000) + " s",
					"Handler: " + POS.events.lockedBy);
			}
			return;
		}
		POS.events.lock();

		var id = element.getAttribute("id");

		if (!id)
			throw 20;

		var parameters = new Array();

		for (var i = 0; i < 3; i++)
			parameters.push(element.getAttribute(event + "_parameter_" + i));

		for (var i in parameters)
			if (parameters[i] == "unlock")
				POS.events.unlock();

		var component = POS.getComponentById(id);

		if (component != null)
			component.eventTrigger(event, parameters, eventObj);
		else
			throw 20;
	} catch (e) {
		POS.events.unlock();
	}
}

CEventDispatcher.prototype.lock = function () {
	this.locked = true;
	this.lockedSince = Date.now();
	this.lockedBy = null;
	this.lockWarned = false;
}

CEventDispatcher.prototype.unlock = function () {
	this.locked = false;
}

CEventDispatcher.prototype.keyupEvent = function (event) {
	POS.events.updateTS(POS.events);

	POS.events.lastFocusedComponent = POS.focusedComponent;
	POS.events.BarcodeReader.readInput(event);
}

CEventDispatcher.prototype.mousemoveEvent = function (event) {
	POS.mover.moveHandler(event);
}

CEventDispatcher.prototype.mouseclickEvent = function (event) {
	//    POS.events.callOnClickEventCallbacks();
}

CEventDispatcher.prototype.mousedownEvent = function (event) {
	POS.events.updateTS(POS.events);

	POS.events.callOnClickEventCallbacks();
	//POS.events.eventTrigger(event.target, "onMousedown", event);
}

CEventDispatcher.prototype.setOnClickEventCallback = function (cls, fnc, onlyOnce) {
	POS.timeout.register("doSetOnClickEventCallback", this.doSetOnClickEventCallback,
		Array(cls, fnc, onlyOnce, this), 1, 1);
}

CEventDispatcher.prototype.doSetOnClickEventCallback = function (param) {
	var cls = param[0];
	var fnc = param[1];
	var onlyOnce = param[2];
	var me = param[3];

	var element = new me.callback();
	element.cls = cls;
	element.fnc = fnc;
	element.onlyOnce = onlyOnce;

	me.callbacks.push(element);
}

CEventDispatcher.prototype.callOnClickEventCallbacks = function () {
	var newCallbacks = new Array();
	var callback = null;

	for (var i = 0; i < POS.events.callbacks.length; i++) {
		callback = POS.events.callbacks[i];

		if (typeof callback.fnc == "function")
			callback.fnc(callback.cls);

		if (callback.onlyOnce != true) {
			var element = new POS.events.callback();

			element.cls = callback.cls;
			element.fnc = callback.fnc;
			element.onlyOnce = callback.onlyOnce;

			newCallbacks.push(element);
		}
	}

	POS.events.callbacks = newCallbacks;
}

export { CEventDispatcher };
